import { useGetDataFromApi } from "../Func/GlobalFunction";

const nilaiList = [
  "Keikhlasan",
  "Keteladanan",
  "Keilmuan",
  "Kemandirian",
  "Ukhuwah",
];

export const VisiMisiSection = () => {
  const { data } = useGetDataFromApi("visimisi/0/0/3");
  const misiList =
    data && data.length > 0
      ? typeof data[0].misi === "string" && data[0].misi.includes(";")
        ? data[0].misi.split(";")
        : []
      : [];
  return (
    <div className="mt-8 font-sans">
      {/* Visi */}
      <p className="text-xs uppercase tracking-widest text-gray-400 mb-1">
        Visi
      </p>
      <div className="border-l-[3px] border-emerald-600 bg-gray-50 rounded-r-xl px-6 py-5 mb-8">
        <p className="font-serif text-lg italic text-gray-800 leading-relaxed">
          {/* "Mencetak generasi Muslim yang berakhlak mulia, berilmu mendalam, dan
          bermanfaat bagi umat dan bangsa." */}
          {data && data.length > 0 ? data[0].visi : ""}
        </p>
      </div>

      <hr className="border-gray-200 mb-8" />

      {/* Misi */}
      <p className="text-xs uppercase tracking-widest text-gray-400 mb-1">
        Misi
      </p>
      <h3 className="font-serif text-lg font-semibold text-gray-800 mb-4">
        Langkah-langkah mewujudkan visi
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {misiList.map((misi, i) => (
          <div
            key={i}
            className="flex gap-3 items-start bg-white border border-gray-200 rounded-xl p-4"
          >
            <div className="w-7 h-7 rounded-full bg-emerald-100 text-emerald-800 text-sm font-medium flex items-center justify-center shrink-0 mt-0.5">
              {i + 1}
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">{misi}</p>
          </div>
        ))}
      </div>

      {/* Nilai */}
      <div className="flex flex-wrap gap-2 mt-6">
        {nilaiList.map((nilai) => (
          <span
            key={nilai}
            className="flex items-center gap-1.5 text-xs px-3.5 py-1.5 rounded-full bg-gray-100 text-gray-500 border border-gray-200"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
            {nilai}
          </span>
        ))}
      </div>
    </div>
  );
};
